import {
  DonationPaymentMethod,
  isManualPaymentNoLogo,
  isPayTrCardPayment,
} from './donationCardsLogoUtils';
import { ProductOrderStatus } from './productOrderConstants';

const matchesOrder = (row, orderId) => {
  if (!orderId || !row) return false;
  return row.sourceId === orderId
    || row.parentSourceId === orderId
    || row.externalSourceId === orderId;
};

export const resolveProductOrderLogoInfo = (detail, ledgerRows = []) => {
  if (!detail) {
    return {
      debtSlipNo: null,
      collectionSlipNo: null,
      showLogoSection: false,
      showPendingWarning: false,
      showManualNote: false,
      isPayTr: false,
    };
  }

  const paymentMethod = detail.paymentMethod;
  const isPayTr = isPayTrCardPayment(paymentMethod)
    || detail.payTrPaymentType === 'card'
    || Boolean(detail.payTrMerchantOid);
  const isManual = isManualPaymentNoLogo(paymentMethod)
    || (paymentMethod !== DonationPaymentMethod.BankTransfer && !isPayTr && detail.status === ProductOrderStatus.Paid);

  const relatedRows = Array.isArray(ledgerRows)
    ? ledgerRows.filter((row) => matchesOrder(row, detail.id))
    : [];

  const debtFromLedger = relatedRows.find(
    (row) => row.externalReference && (row.debitAmount > 0 || row.ledgerKind === 0),
  )?.externalReference;

  const debtSlipNo = detail.lastLogoDebtSlipNo
    || detail.logoDebtSlipNo
    || debtFromLedger
    || null;

  const collectionSlipNo = detail.externalReference
    || detail.paymentExternalReference
    || null;

  const showPendingWarning = detail.status === ProductOrderStatus.Pending
    && isPayTr
    && (detail.payTrCallbackReceivedAt || detail.payTrMerchantOid)
    && !collectionSlipNo;

  const showManualNote = isManual && detail.status === ProductOrderStatus.Paid;
  const showLogoSection = detail.status === ProductOrderStatus.Paid
    && (isPayTr || collectionSlipNo || debtSlipNo);

  return {
    debtSlipNo,
    collectionSlipNo,
    showLogoSection,
    showPendingWarning,
    showManualNote,
    isPayTr,
  };
};

export { DonationPaymentMethod as ProductPaymentMethod };
